module.exports = "<ul id=\"u-menu\">\n  <li *ngFor=\"let p of pageList\" style=\"margin-top: 7px;\">\n    <a href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\" class=\"tooltip\">\n      <img src=\"/assets/images/icons/{{p.KP_Image_URL}}\"> &nbsp;\n      {{p.KHB_Page}}\n      <span style=\"display:block;font-size:13px;\" class=\"tooltiptext\">{{p.KHB_Page}}</span></a></li>  \n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/chitfundmenu/chitfundmenu.component.html
// module id = ./src/app/chitfund/chitfundmenu/chitfundmenu.component.html
// module chunks = main